import { render } from "./AppBreadcrumb.vue?vue&type=template&id=6b22d5ac&scoped=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"

import "./AppBreadcrumb.vue?vue&type=style&index=0&id=6b22d5ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b22d5ac"]])

export default __exports__